import { ListingTypeCtaConfig } from "../../../../../interfaces/ProductObject";

export interface CtaStrategy {
  style: "slider" | "button" | "none";
  primaryLabel: string;
  secondaryLabel: string;
  guestLabel: string;
}

export const DEFAULT_CTA_STRATEGY: CtaStrategy = {
  style: "slider",
  primaryLabel: "Make an Offer",
  secondaryLabel: "Message Seller",
  guestLabel: "Login to Make an Offer",
};

export function buildCtaStrategy(cta: ListingTypeCtaConfig | undefined): CtaStrategy {
  if (!cta) return DEFAULT_CTA_STRATEGY;
  return {
    style: cta.style ?? "slider",
    primaryLabel: cta.primary_label ?? DEFAULT_CTA_STRATEGY.primaryLabel,
    secondaryLabel: cta.secondary_label ?? DEFAULT_CTA_STRATEGY.secondaryLabel,
    guestLabel: cta.guest_label ?? DEFAULT_CTA_STRATEGY.guestLabel,
  };
}
